import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { RouteKey, routeFor } from '../../Routes/routes';
import BayFormContainer from '../../containers/admin/bayManagement/BayFormContainer';
import Page from '../common/Page';

const AddBay: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Page>
            <BayFormContainer
                onAddBayRedirect={() =>
                    navigate(routeFor(RouteKey.BayManagement)())
                }
            />
        </Page>
    );
};

export default AddBay;
